import { Box, Card, IconButton, styled, Tooltip, Typography } from '@mui/material';
import { ArrowForwardIos } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';


const getRandomColor = () => {
  
  const baseColor = [0x0A, 0x85, 0x88]; 
  const colorRange = 120; 
  
  const randomColor = baseColor.map(component =>
    Math.min(255, Math.max(0, component + Math.floor((Math.random() - 0.5) * colorRange)))
  );

  let color = '#';
  randomColor.forEach(component => {
    color += Math.floor(component).toString(16).padStart(2, '0');
  });

  return color;
};



const StyledCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '24px !important',
  cursor:"pointer",
  background: getRandomColor(),
  [theme.breakpoints.down('sm')]: { padding: '16px !important' },
}));

const ContentBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  '& small': { color: 'white' },
  '& .icon': { opacity: 0.6, fontSize: '44px', color: 'white' },
}));


const StatCards = ({ title,icon,value }) => {
  

  const navigate = useNavigate();

  const handleIconButtonClick = (link) => {
    if(link=="Company Admin" ){
      navigate("company", { replace: true });
    }
    else if(link=="Admin Users"){
      navigate("users", { replace: true });
    } 
    else if (!link.toLowerCase().includes("balance for") && link !== "Company Users") {
      navigate(link.toLowerCase(), { replace: true });
    }
    else{
      navigate("/", { replace: true });
    }
  };
  


  return (
          <StyledCard elevation={6} sx={{background:getRandomColor(),width:"100%"}} onClick={() => handleIconButtonClick(title)}>
            <ContentBox sx={{display:"flex",alignItems:"center"}}>
              {icon}
              <Box ml="12px">
                <Typography variant='h6' fontWeight={700}>{title}</Typography>
                <Typography variant='h5' fontWeight={600}>{value}</Typography>
              </Box>
            </ContentBox>

          </StyledCard>
  );
};

export default StatCards;
